import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import Loader from "../../ui/Loader";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import WorkoutPackageForm from "./WorkoutPackageForm";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { workoutPackageDeleteNew } from "../../../data/ApiEndpoints";

const AllWorkoutPackages = ({
  // tbDatas,
  isPage,
  setIsPage,
  callFunction,
  userInfoData,
  modValues,
  setModValues,
  onCloseModalvalues,
}) => {
  const dispatch = useDispatch();
  const { loading, workoutPackages } = useSelector((state) => state.workoutApi);

  const { data, pagination } = workoutPackages || {};
  const { isModOpen, cardName } = modValues || {};

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
    workoutArray: [],
  };
  const [subModValues, setSubModValues] = useState(iniModvalues);

  function closeSubModal() {
    setSubModValues(iniModvalues);
  }

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: workoutPackageDeleteNew,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  const tbColumns = [
    {
      dataField: "plan_name",
      text: "Workout Package",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.plan_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "plan_suitable_for_name",
      text: "Plan suitable for",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.plan_suitable_for_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "pkg_focused_category_name",
      text: "Plan Category",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.pkg_focused_category_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "plan_type_name",
      text: "Plan Goal",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.plan_type_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "plan_access",
      text: "Plan access",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.plan_access?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "plan_duration",
      text: "Plan duration",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.plan_duration || 0} Day(S)
          </span>
        );
      },
    },
    {
      dataField: "workout_days_info",
      text: "workout days",
      formatter: (cell, row) => {
        return (
          <span
            className={`tb-data ${
              row?.workout_days_info?.length > 0 ? "link" : ""
            }`}
            onClick={() =>
              row?.workout_days_info?.length > 0 &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "workout_days_info",
                workoutArray: row.workout_days_info,
                rowData: row,
              }))
            }
          >
            {row?.workout_days_info?.length > 0 ? "View" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "workout_focus_stats",
      text: "Target Muscle",
      formatter: (cell, row) => {
        return (
          <span
            className={`tb-data ${
              row?.workout_focus_stats?.length > 0 ? "link" : ""
            }`}
            onClick={() =>
              row?.workout_focus_stats?.length > 0 &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "workout_focus_stats",
                workoutArray: row.workout_focus_stats,
              }))
            }
          >
            {row?.workout_focus_stats?.length > 0 ? "View" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon view"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "desc",
              }))
            }
            style={{
              border: "1px solid #bc0909",
              color: "#bc0909",
              borderRadius: "12px",
              cursor: "pointer",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-view-list"
              viewBox="0 0 16 16"
            >
              <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
            </svg>
          </button>

          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "edit",
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>

          <button
            className="actionBtn icon copy"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "copy",
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-copy"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
              />
            </svg>
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash3-fill"
                viewBox="0 0 16 16"
              >
                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
              </svg>
            )}
          </button>
        </div>
      ),
    },
  ];

  const workoutDaysTbColumns = [
    {
      dataField: "day_no",
      text: "day no.",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.day_no || 0}</span>;
      },
    },
    {
      dataField: "exercise_id_name",
      text: "Exercise name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.exercise_id_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    // {
    //   dataField: "applicable_for_name",
    //   text: "applicable for_name",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data minWidth150">
    //         {row?.applicable_for_name || "NA"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "exercise_no",
      text: "exercise no.",
      formatter: (cell, row) => {
        return (
          <span className="tb-data" style={{ textTransform: "uppercase" }}>
            {row?.exercise_no || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "rest_time",
      text: "rest time",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.rest_time || 0}</span>;
      },
    },
    {
      dataField: "workout_type",
      text: "workout type",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.workout_type || 0}</span>;
      },
    },
    {
      dataField: "sets",
      text: "sets",
      formatter: (cell, row) => {
        return (
          <span
            className={`tb-data ${row?.sets?.length > 0 ? "link" : ""}`}
            onClick={() =>
              row?.sets?.length > 0 &&
              setSubModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "sets",
                workoutArray: row.sets,
              }))
            }
          >
            {row?.sets?.length > 0 ? "View" : "NA"}
          </span>
        );
      },
    },
  ];

  const workoutStatsTbColumns = [
    {
      dataField: "exercise_muscle_category",
      text: "muscle category name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.exercise_muscle_category_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "total_exercise",
      text: "total exercise",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.total_exercise || 0}</span>;
      },
    },
  ];

  const setsTbColumns = [
    {
      dataField: "weight",
      text: "weight/Duration",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.category_name?.toLowerCase() === "cardio"
              ? row?.duration || 0
              : row?.weight || 0 + "Kg"}
          </span>
        );
      },
    },
    {
      dataField: "reps",
      text: "reps",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.reps || 0}</span>;
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={isModOpen}
        onRequestClose={onCloseModalvalues}
        contentLabel="Workout Package Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            cardName === "desc" ? "details-modal-container" : ""
          }`}
          style={{
            width: cardName === "workout_focus_stats" ? "auto" : "",
            height: cardName === "workout_focus_stats" ? "auto" : "",
          }}
        >
          {cardName !== "add" && cardName !== "edit" && cardName !== "copy" ? (
            <ModalHeadAndClose
              title={`${
                cardName === "desc"
                  ? "Description"
                  : cardName?.replace(/_/g, " ")
              }`}
              onClose={onCloseModalvalues}
            />
          ) : null}

          {cardName === "workout_focus_stats" ? (
            <div className="fullWidthFlexCenter overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={modValues.workoutArray}
                tableColumns={
                  cardName === "workout_days_info"
                    ? workoutDaysTbColumns
                    : cardName === "workout_focus_stats"
                    ? workoutStatsTbColumns
                    : []
                }
              />
            </div>
          ) : cardName === "add" ||
            cardName === "edit" ||
            cardName === "copy" ||
            cardName === "workout_days_info" ? (
            <WorkoutPackageForm
              userInfoData={userInfoData}
              callFunction={callFunction}
              closeModal={onCloseModalvalues}
              isEdit={
                cardName === "edit" ||
                cardName === "copy" ||
                cardName === "workout_days_info"
              }
              rowData={modValues.rowData}
              isCopyPack={cardName === "copy"}
              isViewOnly={cardName === "workout_days_info"}
            />
          ) : cardName === "desc" ? (
            <div className="discussionModalMessage mt30">
              <p
                className="message"
                dangerouslySetInnerHTML={{
                  __html:
                    modValues.rowData?.description || "No Content Available",
                }}
              ></p>
            </div>
          ) : null}
        </div>
      </Modal>

      <Modal
        isOpen={subModValues.isModOpen}
        onRequestClose={closeSubModal}
        contentLabel="Workout Package Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer`}
          style={{
            width: subModValues.cardName === "sets" ? "auto" : "",
            height: subModValues.cardName === "sets" ? "auto" : "",
          }}
        >
          {cardName !== "add" ? (
            <ModalHeadAndClose
              title={`${cardName?.replace(/_/g, " ")}`}
              onClose={closeSubModal}
            />
          ) : null}

          {subModValues.cardName === "sets" ? (
            <div className="fullWidthFlexCenter overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={subModValues.workoutArray}
                tableColumns={setsTbColumns}
              />
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="fullWidthFlexCenter overflowAuto separatedTable">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={Array.isArray(data) && data.length > 0 ? data : []}
            tableColumns={Array.isArray(tbColumns) ? tbColumns : []}
            tablePagination={
              Array.isArray(pagination) && pagination.length > 0
                ? pagination
                : []
            }
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        )}
      </div>
    </>
  );
};

export default AllWorkoutPackages;
